import { Component, OnInit } from '@angular/core';
import {MatDialog, MatDialogRef} from '@angular/material/dialog';

@Component({
  selector: 'app-modal-circular',
  templateUrl: './modal-circular.component.html',
  styleUrls: ['./modal-circular.component.scss']
})
export class ModalCircularComponent implements OnInit {

  constructor(
    public dialog: MatDialog,
    public dialogRef: MatDialogRef<ModalCircularComponent>
  ) { }

  ngOnInit(): void {



  }

  closeModal(): void {

    this.dialogRef.close();
    
  }

}
